import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  IconButton,
  Paper,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import React, { useState, useEffect } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import Page from "../../../../../Components/Dashboard/Page";
import Searchbox from "../../../../../Components/Dashboard/Searchbox";
import {
  components,
  PrintButtonIcon,
} from "../../../../../Components/Icons/DataTableIcons";
import {
  // ColumnTextStyle,
  EditIcon,
  MuiDataTableTheme,
  ViewIcon,
  AwardIcon,
  ActivateIcon,
  DeactivateIcon,
} from "../../../../../Components/MuiDataTableTheme/MuiDataTableTheme";
import ArchiveIcon from "@mui/icons-material/Archive";
import moment from "moment";
import { colors } from "../../../../../Styles/GlobalStyles/Variables";
import StatusGenerator from "../../../../../Components/StatusGenerator/StatusGenerator";
import { ElevatedGreenButton } from "../../../../../Components/Button/CustomButton";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CardActiveLoans from "../../../../../sections/@dashboard/app/CardActiveLoans";
// import CardBenefittedFromGrants from "../../../../../sections/@dashboard/app/CardBenefittedFromGrants";
import CardAllLoans from "../../../../../sections/@dashboard/app/CardAllLoans";
import CardInactiveLoans from "../../../../../sections/@dashboard/app/CardInactiveLoans";
import DialogBox from "../../../../../Components/DialogBox/DialogBox";
import ConfirmDialog from "../../../../../Components/Alert/ConfirmDialog";
import AddNewLoanDialogForm from "../../../../../Components/LoanSetUp/AddNewLoanDialogForm";
import ViewLoanDialog from "../../../../../Components/LoanSetUp/ViewLoanDialog";
import LoansPrintTemplate from "../../../../../Components/PrintFiles/LoansPrintTemplate";
import FilterButton from "../../../../../Components/Button/FilterButton";
import { useDispatch, useSelector } from "react-redux";
import { EmptyRowIcon } from "../../../../../Components/Icons/EmptyRowIcon";
import { clearMsg, infoMsg } from "../../../../../Utils/apiToasts";
import {
  fetchLoans,
  printPartners,
  activateLoan,
  deactivateLoan,
  restoreLoanInitial,
  fetchLoanById,
  fetchLoanSelect,
  emptyLoanSelect,
  exportLoans,
  fetchAllTotalLoanDetails,
  // fetchAllTotalLoanBeneficiaryDetails,
  emptyLBToLoan,
  fetchLBToLoan,
} from "../../../../../Actions";
import AwardLoanDialog from "../../../../../Components/LoanSetUp/AwardLoanDialog";

const getLoanState = (state) => state.loansReducer;
const getUsersState = (state) => state.usersReducer;

LoadingOverlay.propTypes = undefined;

const LoanSetUp = () => {
  const [openDialog, setOpenDialog] = useState({
    open: false,
    Title: "",
    Content: null,
    actionButton: "",
  });
  const [targetLoanData, setTargetLoanData] = useState({});
  const [awardLoanDialogIsOpen, setAwardLoanDialogIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showPrintPreview, setShowPrintPreview] = useState(false);
  const [openNewLoanDialog, setOpenNewLoanDialog] = useState(false);
  const [openViewLoanDialog, setOpenViewLoanDialog] = useState(false);
  const [formType, setFormType] = useState("");
  const [loansTableData, setLoansTableData] = useState([]);
  const [showNoDataMessage, setShowNoDataMessage] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 10;
  const [searchText, setSearchText] = useState("");
  const [filterOptions, setFilterOptions] = useState("");
  const [filters, setFilters] = useState("");
  const dispatch = useDispatch();
  const {
    loansFetched,
    totalLoanCount,
    isLoading,
    loanActivated,
    loanDeactivated,
    loan,
    loanUpdated,
    loanSelectFetched,
    isFetched,
    totalLoanBeneficiaryDetails,
  } = useSelector(getLoanState);
  const { authUser } = useSelector(getUsersState);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    isLoading: false,
    title: "",
    subTitle: "",
    header: "",
    backgroundColor: "",
    borderSideColor: "",
    color: "",
    subColor: "",
    note: false,
  });
  const ColumnTextStyle = {
    textTransform: "capitalize",
    textAlign: "left",
    color: "#212b36",
    fontSize: "0.875rem",
    fontWeight: 600,
  };

  const theParams = {
    PageNumber: pageNumber,
    PageSize: pageSize,
    Search: searchText,
    FilterOptions: filterOptions,
  };

  const handleFilterClick = (event) => {
    setLoading(true);
    setFilterOptions(event);
  };

  const handleReset = () => {
    setFilterOptions("");
    setFilters("");
  };

  // const [zoneValue, setZoneValue] = useState("");
  // const handleZoneChange = () => {};
  const options = [
    {
      type: "radio",
      name: "status",
      group: "Status",
      options: [
        {
          label: "All",
          value: "",
        },
        {
          label: "Active",
          value: true,
        },
        {
          label: "Inactive",
          value: false,
        },
      ],
    },
    {
      type: "sectorAutocomplete",
      name: "sectors",
      group: "Select Sector",
      options: [],
    },
  ];
  const printIdCardArea = () => {
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.srcdoc = document.getElementById("printarea").innerHTML;
    document.body.appendChild(iframe);
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    iframe.contentWindow.close();
    iframe.style.display = "none";
    clearMsg();
  };

  const fireApi = () => {
    return dispatch(fetchLoanSelect());
  };
  const printLoansPdf = async () => {
    await fireApi();
    infoMsg("Loading the print preview window...");
    setShowPrintPreview(true);
  };

  useEffect(() => {
    if (showPrintPreview && loanSelectFetched.length > 0) {
      clearMsg("");
      printIdCardArea();
    } else if (showPrintPreview && loanSelectFetched.length < 0) {
      infoMsg("Loading the print preview window...");
    }
  }, [showPrintPreview, loanSelectFetched]);

  useEffect(() => {
    if (isFetched && showPrintPreview) {
      setShowPrintPreview(false);
      dispatch(emptyLoanSelect());
    }
  }, [isFetched, showPrintPreview, dispatch]);

  const handleOpenAwardLoanDialog = (loanId) => {
    dispatch(fetchLBToLoan(loanId));
    setAwardLoanDialogIsOpen(true);

    const targetLoan = loansFetched.find((loann) => loann.id === loanId);
    setTargetLoanData(targetLoan);
  };

  const handleCloseAwardLoanDialog = () => {
    dispatch(emptyLBToLoan());
    setAwardLoanDialogIsOpen(false);
    setTargetLoanData({});
  };

  const handleOpenNewLoanDialog = () => {
    setOpenNewLoanDialog(true);
    // setFormType("add");
  };
  const handleOpenViewLoanDialog = (id) => {
    // setOpenNewLoanDialog(true);
    setOpenViewLoanDialog(true);
    dispatch(fetchLoanById(id));
    setFormType("view");
  };
  const handleOpenEditLoanDialog = (id) => {
    if (!id) {
      setFormType("edit");
    } else {
      setOpenViewLoanDialog(true);
      dispatch(fetchLoanById(id));
      setFormType("edit");
    }
  };
  const handleCloseNewLoanDialog = () => {
    let params = {
      PageNumber: pageNumber,
      PageSize: pageSize,
    };
    setOpenNewLoanDialog(false);
    dispatch(fetchLoans(params));
    dispatch(fetchAllTotalLoanDetails());
  };
  const handleCloseViewLoanDialog = () => {
    let params = {
      PageNumber: pageNumber,
      PageSize: pageSize,
    };
    setOpenViewLoanDialog(false);
    dispatch(fetchLoans(params));
  };
  const updateLoadingState = () => {
    setLoading(true);
  };

  const activateLoanHandler = (id) => {
    dispatch(activateLoan(id));
    setLoading(true);
    setConfirmDialog({
      ...confirmDialog,
      // isOpen: false,
      isLoading: true,
    });
  };

  const deactivateLoanHandler = (id) => {
    dispatch(deactivateLoan(id));
    setLoading(true);
    setConfirmDialog({
      ...confirmDialog,
      // isOpen: false,
      isLoading: true,
    });
  };

  useEffect(() => {
    if (loanActivated === true) {
      setLoading(true);
      let params = {
        PageNumber: pageNumber,
        PageSize: pageSize,
        Search: searchText,
        FilterOptions: filterOptions,
      };
      setConfirmDialog({
        ...confirmDialog,
        isLoading: false,
        isOpen: false,
      });
      dispatch(fetchLoans(params));
      dispatch(fetchAllTotalLoanDetails());
    }
    return () => {
      dispatch(restoreLoanInitial());
    };
  }, [loanActivated]);

  useEffect(() => {
    if (loanDeactivated === true) {
      setConfirmDialog({
        ...confirmDialog,
        isLoading: false,
        isOpen: false,
      });
      setLoading(true);
      let params = {
        PageNumber: pageNumber,
        PageSize: pageSize,
        Search: searchText,
        FilterOptions: filterOptions,
      };
      dispatch(fetchLoans(params));
      dispatch(fetchAllTotalLoanDetails());
    }
    return () => {
      dispatch(restoreLoanInitial());
    };
  }, [loanDeactivated]);

  //===>this is the useeffect handlling the API dispatch for pagination

  useEffect(() => {
    let params = {};
    params = {
      PageNumber: pageNumber,
      PageSize: pageSize,
      Search: searchText,
    };
    if (filterOptions.status !== "" && filterOptions.status !== undefined) {
      params["FilterOptions.Status"] = filterOptions.status;
    }

    if (filterOptions.sectors !== "" && filterOptions.sectors !== undefined) {
      params["FilterOptions.Sector"] = filterOptions.sectors;
    } else {
      delete params["FilterOptions.Sector"];
    }
    dispatch(fetchLoans(params));
    dispatch(fetchAllTotalLoanDetails());
    return () => {
      dispatch(restoreLoanInitial());
    };
  }, [dispatch, pageNumber, pageSize, searchText, filterOptions]);

  useEffect(() => {
    if (loanUpdated === true) {
      let params = {};
      params = {
        PageNumber: pageNumber,
        PageSize: pageSize,
        Search: searchText,
      };
      if (filterOptions.status !== "") {
        params["FilterOptions.Status"] = filterOptions.status;
      }
      if (
        filterOptions.sectors !== "" &&
        filterOptions.sectors !== 0 &&
        filterOptions.sectors !== undefined
      ) {
        params["FilterOptions.Sector"] = filterOptions.sectors;
      } else {
        delete params["FilterOptions.Sector"];
      }
      dispatch(fetchLoans(params));
      handleCloseNewLoanDialog();
      handleCloseViewLoanDialog();
      return () => {
        dispatch(restoreLoanInitial());
      };
    }
  }, [loanUpdated]);

  // effect  used to populate table data
  useEffect(() => {
    if (loansFetched.length === 0 || loansFetched.length === null) {
      setLoading(false);
      setShowNoDataMessage(true);
    } else if (
      loansFetched.length !== 0 &&
      loansFetched !== null &&
      loansFetched !== undefined
    ) {
      const createTableData = () => {
        let loansTableData = [];
        loansFetched.map((val) => {
          let row = [
            val.name,
            val.partner.name,
            val.amount,
            val.sector,
            val.loanBeneficiary.length,
            val.expiryDate,
            val.dateCreated,
            val.dateModified,
            val.isActive,
            val,
          ];
          return loansTableData.push(row);
        });
        setLoansTableData(loansTableData);
        setLoading(false);
        setShowNoDataMessage(false);
      };
      loansFetched.length > 0 && createTableData();
    } else {
      setLoansTableData([]);
    }
  }, [loansFetched, pageNumber]);

  useEffect(() => {
    if (
      isLoading === false &&
      loansFetched.length > 0 &&
      loansFetched.length === 0
    ) {
      setShowNoDataMessage(true);
      setLoading(false);
    } else {
      setShowNoDataMessage(true);
    }
  }, [isLoading, loansFetched]);

  const changePage = (page) => {
    setLoading(true);
    setPageNumber(page);
  };

  const displayData = [
    { status: true },
    { status: false },
    { status: true },
    { status: false },
  ];

  const figureColumnStyle = {
    paddingRight: "70px",
    fontSize: "14px",
    fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
  };

  const columns = [
    {
      name: "loanname",
      label: "Loan Name",
      options: {
        setCellProps: () => ({ style: { minWidth: "230px", padding: "20px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              <span style={{ marginLeft: "20px" }}>{column.label}</span>
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null
            ? 0
            : value;
        },
        filter: false,
      },
    },
    {
      name: "partner",
      label: "Partner",
      options: {
        setCellProps: () => ({ style: { minWidth: "200px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null
            ? 0
            : value;
        },
        filter: false,
      },
    },
    {
      name: "amount",
      label: "Amount (₦)",
      options: {
        setCellProps: () => ({ style: { minWidth: "150px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          let formattedNumber = new Intl.NumberFormat().format(value);
          return (
            <Typography
              align="right"
              style={figureColumnStyle}
            >{`₦ ${formattedNumber}`}</Typography>
          );
        },
        filter: false,
      },
    },
    {
      name: "sector",
      label: "Sector",
      options: {
        setCellProps: () => ({ style: { minWidth: "160px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null
            ? 0
            : value;
        },
        filter: false,
      },
    },
    {
      name: "noOfLoanBeneficiary",
      label: "No of Loan Beneficiary",
      options: {
        setCellProps: () => ({ style: { minWidth: "110px" }, align: "center" }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null
            ? 0
            : value;
        },
        filter: false,
      },
    },
    {
      name: "expirydate",
      label: "Expiry Date",
      options: {
        setCellProps: () => ({ style: { minWidth: "120px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null
            ? ""
            : moment(value).format("DD/MM/YYYY");
        },
        filter: false,
      },
    },
    {
      name: "datecreated",
      label: "Date Created",
      options: {
        setCellProps: () => ({ style: { minWidth: "120px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null
            ? ""
            : moment(value).format("DD/MM/YYYY");
        },
        filter: false,
      },
    },
    {
      name: "dateactivated",
      label: "Date Activated",
      options: {
        setCellProps: () => ({ style: { minWidth: "120px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return value === undefined || value === "" || value === null
            ? ""
            : moment(value).format("DD/MM/YYYY");
        },
        filter: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        sort: false,
        setCellProps: () => ({ style: { minWidth: "100px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          switch (value) {
            case true:
              return (
                <StatusGenerator statusText="Active" variant="greenFilled" />
              );
            case false:
              return (
                <StatusGenerator statusText="Inactive" variant="redFilled" />
              );
            default:
              return "no status";
          }
        },
        filter: true,
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        sort: false,
        filterType: false,
        filter: false,
        setCellProps: () => ({ style: { minWidth: "130px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <Tooltip title={"View Loan"}>
                <IconButton
                  size="small"
                  onClick={() => handleOpenViewLoanDialog(value.id)}
                >
                  <ViewIcon icon="material-symbols:visibility-outline" />
                </IconButton>
              </Tooltip>

              {authUser.role !== "SAED_State_Coordinator" &&
                authUser.role !== "SAED_State" &&
                authUser.role !== "SAED_LGI" && (
                  <>
                    <Tooltip title={"Edit Loan"}>
                      <IconButton
                        size="small"
                        onClick={() => {
                          handleOpenEditLoanDialog(value.id);
                          dispatch(printPartners());
                        }}
                      >
                        <EditIcon icon="icon-park-outline:edit" />
                      </IconButton>
                    </Tooltip>
                    {value.isActive === false ? (
                      <Tooltip title={"Activate Loan"}>
                        <IconButton
                          size="small"
                          onClick={() =>
                            setConfirmDialog({
                              isOpen: true,
                              title: `Are you sure you want to activate ${value.name}?`,
                              header: `Activate ${value.name}`,
                              // backgroundColor: colors.successDialogBg,
                              // borderSideColor: colors.darkSuccessDialog,
                              color: colors.primaryGreen,
                              subColor: colors.successDialogSubTitle,
                              onConfirm: () => {
                                activateLoanHandler(value.id);
                              },
                            })
                          }
                        >
                          <ActivateIcon icon="fluent-mdl2:activate-orders" />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title={"Deactivate Loan"}>
                        <IconButton
                          size="small"
                          onClick={() =>
                            setConfirmDialog({
                              isOpen: true,
                              title: `Are you sure you want to deactivate ${value.name}?`,
                              header: `Deactivate ${value.name}`,
                              // backgroundColor: colors.successDialogBg,
                              // borderSideColor: colors.darkSuccessDialog,
                              color: colors.primaryGreen,
                              subColor: colors.successDialogSubTitle,
                              onConfirm: () => {
                                deactivateLoanHandler(value.id);
                              },
                            })
                          }
                        >
                          <DeactivateIcon icon="fluent-mdl2:deactivate-orders" />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title={"Award Loan"}>
                      <IconButton
                        size="small"
                        onClick={() => {
                          handleOpenAwardLoanDialog(value.id);
                        }}
                      >
                        {/* clarity:assign-user-solid */}
                        <AwardIcon icon="clarity:assign-user-line" />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
            </>
          );
        },
      },
    },
  ];

  const handleChange = (e) => {
    let searchValue = e.target.value;
    setSearchText(searchValue);
  };

  const CustomToolbarSelect = () => {
    const handleClickArchive = () => {
      // this.props.setSelectedRows([]);
    };
    return (
      <div style={{ marginRight: " 24px" }}>
        {/* <Tooltip title={`Archive ${columns[0]?.name}`}> */}
        <IconButton onClick={handleClickArchive}>
          <ArchiveIcon />
        </IconButton>
        {/* </Tooltip> */}
      </div>
    );
  };

  const paginationOptions = {
    selectableRows: "none",
    jumpToPage: true,
    serverSide: true,
    count: totalLoanCount,
    page: pageNumber - 1,
    // rowsPerPage: 10,
    rowsPerPageOptions: [],
    print: false,
    // searchText: searchText,
    search: false,
    // searchPlaceholder: "Search for Loans",

    customToolbar: () => {
      return (
        <>
          <Tooltip title="Print Table">
            <IconButton onClick={printLoansPdf}>
              <PrintButtonIcon />
            </IconButton>
          </Tooltip>
          <FilterButton
            options={options}
            filters={filters}
            onClick={handleFilterClick}
            reset={handleReset}
          />
          {authUser.role !== "SAED_State_Coordinator" &&
            authUser.role !== "SAED_State" &&
            authUser.role !== "SAED_LGI" && (
              <ElevatedGreenButton
                onClick={() => {
                  handleOpenNewLoanDialog();
                  dispatch(printPartners());
                }}
                startIcon={<AddOutlinedIcon />}
              >
                Add New Loan
              </ElevatedGreenButton>
            )}
        </>
      );
    },

    onDownload: (buildHead, buildBody, columns, data) => {
      dispatch(exportLoans());
      return false;
    },

    onSearchChange: (setSearch, param) => {
      dispatch(fetchLoans(param));
    },

    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        setLoading(true);
        // if (tableState.page === 0){
        //   setPageNumber(0);
        // }else{
        changePage(tableState.page + 1);
        // }
        return () => {
          setLoading(false);
        };
      }
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <CustomToolbarSelect
        selectedRows={selectedRows}
        displayData={displayData}
        setSelectedRows={setSelectedRows}
      />
    ),
    disableRipple: true,
    filter: false,
    elevation: 0,
    filterType: "dropdown",
    responsive: "standard",
    fixedHeader: true,
    // print:false,
    tableBodyHeight: "600px",
    tableBodyMaxHeight: "1000px",
    // rowsPerPageOptions: [10, 50, 100],

    textLabels: {
      body: {
        noMatch: showNoDataMessage ? <EmptyRowIcon /> : "",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        // columnToolBarSelect: function()(selectedRows, displayData, selectedRows)=>void,
      },
      pagination: {
        next: "Next Page",
        previous: "Previous Page",
        rowsPerPage: "Rows per page:",
        displayRows: "of",
      },
      toolbar: {
        search: "Search",
        downloadCsv: "Export sheet",
        print: "Print page",
        viewColumns: "View columns",
        filterTable: "Filter table",
      },
      filter: {
        all: "All",
        title: "FILTERS",
        reset: "RESET",
      },
      viewColumns: {
        title: "Show Columns",
        titleAria: "Show/Hide Table Columns",
      },
      selectedRows: {
        text: "row(s) selected",
        delete: "Delete",
        deleteAria: "Delete Selected Rows",
      },
    },
  };

  return (
    <Page title="SAED | Loan Setup">
      {/* <TextField value={searchText} onChange={(e)=>handleChange(e)}/> */}
      <Container maxWidth="xl">
        <Box sx={{ pb: 2 }}>
          <Typography
            variant="h5"
            style={{ fontWeight: 600, color: "#212B36" }}
          >
            Loan Management &gt;
            <span
              style={{
                fontWeight: 100,
                fontSize: "1.09rem",
                color: "#909090",
                marginLeft: "10px",
              }}
            >
              Loan Set-up
            </span>
          </Typography>
        </Box>
        <Box sx={{ pb: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md>
              <CardAllLoans />
            </Grid>
            <Grid item xs={12} sm={6} md>
              <CardActiveLoans />
            </Grid>
            <Grid item xs={12} sm={6} md>
              <CardInactiveLoans />
            </Grid>
            {/* <Grid item xs={12} sm={6} md>
              <CardBenefittedFromGrants />
            </Grid> */}
          </Grid>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box>
              <Paper
                sx={{
                  boxShadow: "0 1px 2px 0 rgb(145 158 171 / 24%)",
                  borderRadius: "20px",
                }}
              >
                <Card
                  elevation={0}
                  sx={{ padding: "0px !important", borderRadius: "20px" }}
                >
                  <CardContent sx={{ padding: "0px !important" }}>
                    <ThemeProvider theme={MuiDataTableTheme}>
                      <LoadingOverlay
                        active={loading}
                        styles={{
                          overlay: (base) => ({
                            ...base,
                            background: "rgba(0, 0, 0, 0.15)",
                          }),
                        }}
                        spinner
                        text="Fetching Data for You..."
                      >
                        <MUIDataTable
                          title={
                            <Box
                              display="flex"
                              alignItems="center"
                              gap={10}
                              justifyContent="space-between"
                            >
                              <Typography
                                sx={{ color: "#05004E", fontWeight: 600 }}
                              >
                                Loan Set-up
                              </Typography>
                              <Searchbox
                                size={"300px"}
                                placeholder="Loans"
                                onChange={handleChange}
                                value={searchText}
                              />
                            </Box>
                          }
                          data={loansTableData}
                          columns={columns}
                          options={paginationOptions}
                          displayData={displayData}
                          components={components}
                          style={{ transition: "0.7s" }}
                        />
                      </LoadingOverlay>
                    </ThemeProvider>
                  </CardContent>
                </Card>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <div id="printarea" style={{ display: "none" }}>
        <LoansPrintTemplate />
      </div>
      <DialogBox openDialog={openDialog} setOpenDialog={setOpenDialog} />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
      <AddNewLoanDialogForm
        openNewLoanDialog={openNewLoanDialog}
        handleCloseNewLoanDialog={handleCloseNewLoanDialog}
        formType={formType}
        updateLoadingState={updateLoadingState}
      />
      <ViewLoanDialog
        openViewLoanDialog={openViewLoanDialog}
        handleCloseViewLoanDialog={handleCloseViewLoanDialog}
        handleOpenEditLoanDialog={handleOpenEditLoanDialog}
        loan={loan}
        formType={formType}
        theParams={theParams}
        updateLoadingState={updateLoadingState}
      />
      <AwardLoanDialog
        isOpen={awardLoanDialogIsOpen}
        onCloseHandler={handleCloseAwardLoanDialog}
        loanDetails={targetLoanData}
        // awardedCM={"Hello there💦"}
      />
    </Page>
  );
};

export default LoanSetUp;
